import { Component, Input, OnInit } from '@angular/core';

import { SortOrder } from '@bayclubs/court-booking-employee-api';

@Component({
    selector: 'app-sort-order',
    templateUrl: './sort-order.component.html',
    styleUrls: ['./sort-order.component.scss'],
    standalone: false
})
export class SortOrderComponent implements OnInit {

    @Input() sort: SortOrder;

    constructor() { }

    ngOnInit(): void { }

    get isNone(): boolean {
        return this.sort === SortOrder.None;
    }

    get isAscending(): boolean {
        return this.sort === SortOrder.Asc;
    }

    get isDescending(): boolean {
        return this.sort === SortOrder.Desc;
    }
}
